import React from "react";
import PropTypes from "prop-types";
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { Subscribe } from "unstated";
import { FormattedMessage } from "react-intl";
import Container from "react-bootstrap/Container";
import { CreditCardPaymentLoading } from "./";
import { myGlobals, myUtilities } from "../../Utils";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";


class GuestPayDirectDebitDI extends React.Component {
    constructor(props) {
        super(props);
        this.requestSent = false;
        this.state = {
            status: "loading",
        };
        this.guestPayDirectDebitUrl = null;
        this.failureResponse="failed";
    }
    
    responseHandler = (data) => {

        if (data != undefined && data.rows != undefined && data.rows.failureReason && data.rows.failureReason === 'LINK_EXPIRED') {
            myGlobals.errorMessage = myUtilities.accountSpecificLanguage("Error.LinkExpired", "Link has expired");
            myGlobals.getHistory.replace(`/linkExpired`);
            return;
        }

        if (data.success.toString().localeCompare("true") === 0) {
            if (data.msg) {
                this.guestPayDirectDebitUrl = data.msg;
                this.setState({ status: "show" });

            } else {
                //Request Time Out
                this.setState({ status: "requestTimeOut" });
            }

        } else {
            //Failed
            this.failureResponse= data.msg?data.msg: myUtilities.accountSpecificLanguage("DirectDebit.DefaultFailure", "Invalid ACH Payment");
            this.setState({ status: "failed" });

        }
    }

    getGuestPayDirectDebitConfig = (data, paymentData, responseHandler) => {

        let remittanceFormData = data.state.remittanceFormData;
        let requestMap = new Map();
        if (data.state.paymentOnAccount) {
            console.log("customerId : " + data.state.pkMcarId);
            requestMap.set('supplierId', window.rsaEncrypt(data.state.onDemandAccountId));
            requestMap.set('payThroughEmail', window.rsaEncrypt(true));
            requestMap.set('customerMapId', window.rsaEncrypt(data.state.pkMcarId));
            requestMap.set('saveBankAccountForReuse', window.rsaEncrypt(false));
            requestMap.set('isSupplier', window.rsaEncrypt(false));
            requestMap.set('totalAmount', window.rsaEncrypt(data.state.payableAmount));
            requestMap.set('currency', window.rsaEncrypt(data.state.currency));
            requestMap.set('token', encodeURIComponent(myGlobals.token));
            requestMap.set('directDebitFlow', window.rsaEncrypt(data.state.isPMTDIEnabled));
            requestMap.set('langCode', window.rsaEncrypt(myGlobals.languageCode));
            if (remittanceFormData !== null) {
                const keys = Object.keys(remittanceFormData);
                for (let i = 0; i < keys.length; ++i) {
                    requestMap.set(keys[i], window.rsaEncrypt(remittanceFormData[keys[i]]));
                }
            }
        }
        else {
            let invoices = data.state.selectedInvoices;
            const partialPaymentEnabled = data.state.partialPaymentEnabledForGuestPay === true;
            let invoiceList = invoices.map((invoice) => {
                const originalAmt = invoice.payableAmount2 !== undefined ? invoice.payableAmount2 : invoice.payableAmount;
                if (partialPaymentEnabled) {
                    const isPartialEdited = parseFloat(invoice.payableAmount) < parseFloat(originalAmt);
                    const disputeAmt = isPartialEdited ? invoice.payableAmount : originalAmt;
                    const reasonCode = (isPartialEdited && invoice.partialPaymentReason) ? invoice.partialPaymentReason : null;
                    const comments = (isPartialEdited && reasonCode) ? (invoice.partialPaymentComments || null) : null;
                    return invoice.accountDocHeaderId + '@' + originalAmt + '@' + disputeAmt + '@' + reasonCode + '@' + comments;
                }
                // Partial payment not enabled — original format, existing createDisputes flow handles reason/comments
                return invoice.accountDocHeaderId + '@' + originalAmt + '@' + invoice.disputeAmount + '@' + invoice.reasonCodeId;
            })
            let currency = invoices[0].currency;
            requestMap.set('invoiceNumbers', (invoiceList));
            requestMap.set("processPartialInvoices", window.rsaEncrypt(myGlobals.processPartialInvoices));
            requestMap.set('onDemandAccountId', window.rsaEncrypt(data.state.onDemandAccountId));
            requestMap.set('pkMapCustomerAccountRad', window.rsaEncrypt(data.state.pkMcarId));
            requestMap.set('globalAccountId', window.rsaEncrypt(data.state.globalAccountId));
            requestMap.set('currency', window.rsaEncrypt(currency));
            requestMap.set('token', window.rsaEncrypt(data.state.token));
            requestMap.set('publicKey', (data.state.publicKey));
            requestMap.set('directDebitFlow', window.rsaEncrypt(data.state.isPMTDIEnabled));
            requestMap.set('langCode', window.rsaEncrypt(myGlobals.languageCode));
        }

        if (!this.requestSent && this.state.status.localeCompare("loading") === 0) {
            let myBody = '';
            let link;
            if (requestMap.get('payThroughEmail') === undefined)
                link = 'payForInvoicesViaACH';
            else
                link = 'invokeACHPaymentOnAccountWithoutLogin';
            let keys = [...requestMap.keys()]
            keys.forEach((item, index) => {
                myBody += item + '=' + requestMap.get(item) + '&';
            })
            myBody = myBody.substring(0, myBody.length - 1);
            link = myGlobals.initialHost + myGlobals.appender + link
           // link = "https://api.npoint.io/0506686d8f6d9c72a962";
            fetch(link, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: myBody
            }).then(
                function (response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem. Status Code: ' +
                            response.status);
                        return;
                    }
                    return response.json();
                }
            ).then(function (data) {
               // data = { "success": true, "msg": "https://fit-gateway.paymentsradius.com/gateway/?token\u003d91b1f8c6-e237-4b7a-b65b-ed06426ef4c1-1772609824253", "displayMsg": "f53bd80c89e742cb9e689fa710b256881772609823430" };
                responseHandler(data);
            })
                .catch(function (err) {
                    console.log("Fetch Error :-S", err);
                    //onFailure(err);
                });
            this.requestSent = true;
        }

    }

    renderGuestPayDirectDebitContent = ( guestPayDirectDebitUrl ) => {
        console.log("Rendering Guest Pay Direct Debit Content with URL:", guestPayDirectDebitUrl);
        return (
            <Row>
                <Col sm={12} style={{ height: "100vh", width: "100vw" }}>
                    <iframe
                        name="paymentsOnDemand"
                        src={guestPayDirectDebitUrl}
                        title="Payments On Demand Frame"
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            position: "relative",
                        }}
                    />
                </Col>
            </Row>
        );
    };

    showContentBasedOnStatus = (invdata) => {
        if (this.state.status.localeCompare("loading") === 0) {
            myGlobals.isACHFlow = true;
             myGlobals.isDirectDebitLoaded = true;
            return <CreditCardPaymentLoading />;
        }
        else if (this.state.status.localeCompare("requestTimeOut") === 0) {
            return (
                <div>
                    <FormattedMessage
                        id="DirectDebit.RequestTimeOutDIPage"
                        defaultMessage={myUtilities.accountSpecificLanguage("DirectDebit.RequestTimeOut", "Request time out. Please try again later.")}
                    />
                </div>
            );
        } else if (this.state.status.localeCompare("failed") === 0) {
            console.log("Guest Pay Direct Debit Failed with message:", this.failureResponse);
          return(  
           <div>
                <FormattedMessage
                    id="DirectDebit.FailedResponseDIPage"
                    defaultMessage={this.failureResponse}
                />
            </div>
          );
        } else if (this.state.status.localeCompare("show") === 0) {
            return this.renderGuestPayDirectDebitContent(this.guestPayDirectDebitUrl);
        }else{
            return(  
                <div>
                     <FormattedMessage
                         id="DirectDebit.DefaultFailedResponseDIPage"
                         defaultMessage={myUtilities.accountSpecificLanguage("DirectDebit.DefaultFailure", "Invalid ACH Payment")}
                     />
                 </div>
               );
        }

    };
    render() {
        return (
            <Subscribe to={[PaymentDataContainer]}>
                {(paymentData) => (
                    <Subscribe to={[InvoiceDataContainer]}>
                        {(invdata) => (
                            <Container>
                                {this.getGuestPayDirectDebitConfig(
                                    invdata,
                                    paymentData,
                                    this.responseHandler
                                )}
                                {this.showContentBasedOnStatus(invdata)}
                            </Container>
                        )}
                    </Subscribe>
                )}
            </Subscribe>
        );
    }

}
export default GuestPayDirectDebitDI;
